import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import logo from '../../assets/logolong.png';

const Footer = () => {
    const [year, setYear] = useState('');
    useEffect(() => {
        var d = new Date();     
        setYear(d.getFullYear());
    });
    const logoStyle = {
        paddingTop: '0px',
        width: 'auto',
        height: '60px',
    };
    const footerStyle = {
        // width: '100%',
        // height: '150px',
        // position: 'absolute',
        // bottom: 0
      };
  return (
      <div style={footerStyle}>
    <Container >
        <br/>
        <img src="/assets/logolong.png" style={logoStyle} alt="Logo" /><br/>
        Essential Skills &#169; {year} &nbsp;
            <a href="https://essentialskills.com/terms-of-service" target="_bank">Terms of Service</a> |&nbsp;
            <a href="https://essentialskills.com/privacy-policy" target="_bank">Privacy Policy</a> |&nbsp;
            <a href="https://essentialskills.com/contact-us " target="_bank">Contact Us</a>
        <br/>&nbsp;<br/>&nbsp;        
    </Container>
    </div>
  );
};

export default Footer;